// import axios from "axios";
// import { authHeader } from "./auth-header";

export const userService = {
  login,
  logout,
  register,
  // getAll,
};

function login(username, password) {
  const urlBackend = `${process.env.VUE_APP_API_BASE_URL}`;
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      client_id: `${process.env.VUE_APP_API_CLIENT_ID}`,
      client_secret: `${process.env.VUE_APP_API_CLIENT_SECRET}`,
      grant_type: "password",
      username,
      password,
      scope: "*",
    }),
  };

  return fetch(`${urlBackend}/oauth/token`, requestOptions)
    .then(handleResponse)
    .then((token) => {
      const data_token = {
        ...token,
        // username: username,
        // password: password,
      };
      // login successful if there's a jwt token in the response
      if (data_token !== "Tidak Ada Akses") {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("token", JSON.stringify(data_token));
      }
      return data_token;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("token");
}

function register(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };
  return fetch(`/users/register`, requestOptions).then(handleResponse);
}

// async function getAll() {
//   await axios
//     .get(process.env.VUE_APP_API_BASE_URL + "/api/me", {
//       headers: authHeader(),
//     })
//     .then(function(response) {
//       return response.data;
//       // handle success
//       // console.log(response.data);
//       // return this.profile;
//     })
//     .catch(function(error) {
//       // handle error
//       console.log(error);
//     });
// }

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
